export default function handleError(error: unknown) {
  return error instanceof Error ? error.message : String(error);
}
